module.exports = __webpack_public_path__ + "img/20200418112911TIM截图20200418111816.0a5f00cb.png";